import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-324f14ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rule-msg-box-wrap" }
const _hoisted_2 = { class: "rule-msgbox-title-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "投注记录", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar-line" }, null, -1))
const _hoisted_5 = { class: "msgbox-body-wrap" }
const _hoisted_6 = { class: "content-header" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "d-calendar" }
const _hoisted_11 = { class: "flex justify-center items-center" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "content-wrap" }
const _hoisted_16 = { class: "mask" }
const _hoisted_17 = { class: "table" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "桌号"),
    /*#__PURE__*/_createElementVNode("th", null, "游戏编号"),
    /*#__PURE__*/_createElementVNode("th", null, "游戏类型"),
    /*#__PURE__*/_createElementVNode("th", null, "投注类型"),
    /*#__PURE__*/_createElementVNode("th", null, "游戏结果"),
    /*#__PURE__*/_createElementVNode("th", null, "牌型"),
    /*#__PURE__*/_createElementVNode("th", null, "输赢"),
    /*#__PURE__*/_createElementVNode("th", null, "日期")
  ])
], -1))
const _hoisted_19 = { class: "td-content" }
const _hoisted_20 = ["data-game"]
const _hoisted_21 = ["data-game"]
const _hoisted_22 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_mj_pgnation = _resolveComponent("mj-pgnation")!

  return (_openBlock(), _createElementBlock("div", {
    class: "rule-msg-box-root",
    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        }),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, "总投注: " + _toDisplayString(_ctx.totalBetAmount), 1),
          _createElementVNode("div", _hoisted_8, " 总有效投注: " + _toDisplayString(_ctx.totalBetValidAmount), 1),
          _createElementVNode("div", _hoisted_9, "总输赢: " + _toDisplayString(_ctx.totalWinResult), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_date_picker, {
              locale: _ctx.lang,
              modelValue: _ctx.dateValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateValue) = $event)),
              "is-dark": "",
              mode: "dateTime",
              color: "gray",
              "is-range": ""
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("input", _mergeProps({
                    value: inputValue.start
                  }, _toHandlers(inputEvents.start), { class: "input-c" }), null, 16, _hoisted_12),
                  _hoisted_13,
                  _createElementVNode("input", _mergeProps({
                    value: inputValue.end
                  }, _toHandlers(inputEvents.end), { class: "input-c" }), null, 16, _hoisted_14)
                ])
              ]),
              _: 1
            }, 8, ["locale", "modelValue"])
          ]),
          _createElementVNode("div", {
            class: "btn-submit",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchDataToaPeriodOfTime && _ctx.fetchDataToaPeriodOfTime(...args)), ["prevent"]))
          }, " 确定 ")
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataInfoList, (i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: i.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(i.tableNo), 1),
                    _createElementVNode("td", null, _toDisplayString(i.gameNo), 1),
                    _createElementVNode("td", null, _toDisplayString(i.gameTypeName), 1),
                    _createElementVNode("td", null, _toDisplayString(i.expand.betContent), 1),
                    _createElementVNode("td", null, _toDisplayString(i.gameResult), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", {
                          "data-game": 
                                                    i.gameTypeNo === 'G002'
                                                        ? '庄'
                                                        : '龙'
                                                ,
                          class: "handred"
                        }, [
                          (i.expand.bankerOne)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(`p_${i.expand.bankerOne}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.bankerOne
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.bankerTwo)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(`p_${i.expand.bankerTwo}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.bankerTwo
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.bankerThree)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(`p_${i.expand.bankerThree}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.bankerThree
                                                        )), 3))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_20),
                        _createElementVNode("div", {
                          "data-game": 
                                                    i.gameTypeNo === 'G002'
                                                        ? '闲'
                                                        : '虎'
                                                ,
                          class: "handblue"
                        }, [
                          (i.expand.playerOne)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(`p_${i.expand.playerOne}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.playerOne
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.playerTwo)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(`p_${i.expand.playerTwo}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.playerTwo
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.playerThree)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(`p_${i.expand.playerThree}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.playerThree
                                                        )), 3))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_21)
                      ])
                    ]),
                    _createElementVNode("td", {
                      class: _normalizeClass({ win: i.expand.winResult > 0 })
                    }, _toDisplayString(i.expand.winResult), 3),
                    _createElementVNode("td", null, _toDisplayString(i.betTime), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_ctx.hasData)
              ? (_openBlock(), _createBlock(_component_mj_pgnation, {
                  key: 0,
                  pageSize: _ctx.pageSize,
                  pageNo: _ctx.pageNo,
                  totalPage: _ctx.totalPage,
                  totalSize: _ctx.totalSize,
                  onGotoPage: _ctx.toPage
                }, null, 8, ["pageSize", "pageNo", "totalPage", "totalSize", "onGotoPage"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}